import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TransactionDetails from './transaction-details';
import TransactionDetailsDetail from './transaction-details-detail';
import TransactionDetailsUpdate from './transaction-details-update';
import TransactionDetailsDeleteDialog from './transaction-details-delete-dialog';

const TransactionDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TransactionDetails />} />
    <Route path="new" element={<TransactionDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<TransactionDetailsDetail />} />
      <Route path="edit" element={<TransactionDetailsUpdate />} />
      <Route path="delete" element={<TransactionDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TransactionDetailsRoutes;
